export default "__VITE_ASSET__BUkFyxJp__"